import type { RouteRecordRaw } from 'vue-router'

/**
 * Sales Admin — Web管理后台 路由配置
 * 对齐 v3.3 §1.2 Web管理后台页面
 * 导航重组：知识库管理 → 销售语料，话术库合并入销售语料，知识库底座独立
 */

const salesAdminRoutes: RouteRecordRaw[] = [
  // 登录页（独立路由，不在侧边栏显示）
  { path: 'login', name: 'SalesAdminLogin', component: () => import('./pages/Login.vue'), meta: { title: '登录' } },
  { path: 'team-dashboard', name: 'SalesAdminTeamDashboard', component: () => import('./pages/TeamDashboard.vue'), meta: { title: '📊 团队看板' } },
  { path: 'team-mama', name: 'SalesAdminTeamMama', component: () => import('./pages/TeamMama.vue'), meta: { title: '💝 团队妈妈' } },
  { path: 'device-manage', name: 'SalesAdminDeviceManage', component: () => import('./pages/DeviceManage.vue'), meta: { title: '🎧 设备管理' } },
  { path: 'user-manage', name: 'SalesAdminUserManage', component: () => import('./pages/UserManage.vue'), meta: { title: '👥 用户管理' } },
  { path: 'enterprise-config', name: 'SalesAdminEnterpriseConfig', component: () => import('./pages/EnterpriseConfig.vue'), meta: { title: '🏢 企业能力配置' } },
  { path: 'signal-config', name: 'SalesAdminSignalConfig', component: () => import('./pages/SignalConfig.vue'), meta: { title: '🎯 信号识别配置' } },
  { path: 'task-review', name: 'SalesAdminTaskReview', component: () => import('./pages/TaskReview.vue'), meta: { title: '📋 任务审核' } },
  { path: 'card-templates', name: 'SalesAdminCardTemplates', component: () => import('./pages/CardTemplateLibrary.vue'), meta: { title: '📇 卡片模板库' } },
]

const salesAdminLayout: RouteRecordRaw = {
  path: '/',
  name: 'SalesAdmin',
  component: () => import('./SalesAdminPlatform.vue'),
  redirect: '/team-dashboard',
  children: salesAdminRoutes,
  meta: { title: '企业主助攻训APP后台' },
}

export const salesAdminRouteConfig = {
  layout: salesAdminLayout,
  routes: salesAdminRoutes,
}

export default salesAdminRoutes
